import { Navigate, Outlet, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import "./styles.scss";
import Sidebar from "components/common/Sidebar";
import Topbar from "components/common/Topbar";
import { selectIsLoading, selectIsMobileView, selectIsShowSidebar, selectIsSuperAdminRole, updateIsShowSidebar } from "redux/features/appStateSlice";
import { useAppDispatch, useTypedSelector } from "redux/store";
import { useAuth } from "hooks/useAuth";
import Overlay from "components/overlay";
import LoadingCard from "components/common/LoadingCard";
import { useEffect } from "react";
import { setDefaultHumeta, setLogo, setSmallLogo } from "../../../redux/features/logoSlice";

const MainLayout = () => {
  let location = useLocation();
  const isSuperAdmin = useTypedSelector(selectIsSuperAdminRole);
  const isMobileView = useTypedSelector(selectIsMobileView);
  const isShowSidebar = useTypedSelector(selectIsShowSidebar);
  const auth = useAuth();
  const dispatch = useAppDispatch();
  const isLoading = useTypedSelector(selectIsLoading);

  console.log("auth--->",auth)

  const setSidebar = () => {
    dispatch(updateIsShowSidebar({show: false}));
  }
  useEffect(()=>{
    console.log("auth changed--->",auth)
    if(auth && auth.user && auth.user.agentDetails){
      dispatch(setLogo(auth.user.agentDetails.config.main_logo))
      dispatch(setSmallLogo(auth.user.agentDetails.config.side_logo))
      dispatch(setDefaultHumeta(false))
    }
  },[auth])

  if(isLoading) return (<LoadingCard />)
  if(auth && auth?.user?.isAgentUser && !auth?.user?.isAgentUserActive && location.pathname !== "/agency-topic-events") {
      return <Navigate to="/agency-topic-events" replace />;
  } 
  return (
    <Container fluid className={"p-0 m-0"}>
      <section>
        <Sidebar />
       
        <div
          className={`right-area ${isMobileView ? "right-area-100" : !isSuperAdmin ? "right-area-client" : "right-area-admin"}`}
          
        >
          {
            isSuperAdmin &&
          <Topbar />
          }
          <div className={`main ${!isSuperAdmin ? "main-client" : ""}`}
          >
            <Outlet />
          </div>
        </div>
        {isShowSidebar && isMobileView && <Overlay isOpen={isShowSidebar && isMobileView} onClose={setSidebar}/>}
      </section>
    </Container>
  );
};

export default MainLayout;